import React from 'react'
import PropTypes from 'prop-types'

import TextField from '../TextField'
import BranchSelect from 'component/branch/BranchSelect'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import moment from 'moment'
import successIcon from 'images/irc-success.svg'
import errorIcon from 'images/irc-error.svg'
import warningIcon from 'images/irc-warning.svg'
import './styles.css'
import FileInput from 'component/FileInput'
import CounterInput from 'component/CounterInput'
import Papa from "papaparse";
import SupplyModal from './SupplyModal'
import WarningModal from 'component/scheduleBlock/WarningModal'
import { isEmpty } from 'utils/validations'
import model from './csvSupplyListModel'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import SupplyItemsNotFoundBox from './SupplyItemsNotFoundBox'

const fileAlerts = [
  { type: 'success', icon: successIcon, message: ['irc.supply.upload.success.msg'] },
  { type: 'warning', icon: warningIcon, message: ['irc.supply.upload.warning.msg', 'L12-30-4, L12-30-5, L12-30-6, L12-30-7'] },
  { type: 'error', icon: errorIcon, message: ['irc.supply.upload.error.msg.1', 'irc.supply.upload.error.msg.2'] }
]

const INITIAL_STATE = {
  positionsNotFound: [],
  positionsFound: [],
  depositsNotFound: [],
  loading: false,
  loadingCsv: false,
  errorText: '',
  isValidCsv: null,
  errorOnStruct: false,
  cleanFile: true

}

class UploadModal extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    file: PropTypes.any,
    currentItem: PropTypes.object,
    newValues: PropTypes.object,
    toggleUpload: PropTypes.func,
    validateProducts: PropTypes.func,
    productsValidation: PropTypes.any,
    onSubmit: PropTypes.func,
    isUserMatriz: PropTypes.bool.isRequired,
    maxRange: PropTypes.number.isRequired,
  }

  state = {
    showWarningModal: false,
    values: {
      dsListName: '',
      positionsPerDay: 1,
      period: [],
      idBranch: '',
    },
    positionsNotFound: [],
    positionsFound: [],
    depositsNotFound: [],
    loading: false,
    loadingCsv: false,
    fileAlert: fileAlerts[0],
    errorText: '',
    isValidCsv: null,
    errorOnStruct: false,
  }

  componentDidMount() {

    const {user, isUserMatriz} = this.props
    const {values} = this.state
    
    if(!isUserMatriz) {
      this.setState({...INITIAL_STATE, values: {...values, dsListName: "", idBranch: user.locationCode.padStart(4, '0')}})
    }
  }


  handleFile = () => {
    const { file, toggleUpload } = this.props

    if (file instanceof Blob) {
      const dsListName = file.name || ''

      this.handleChange('dsListName', dsListName)
    } else {
      toggleUpload(false)
    }
  }

  handleChange = (name, value) => {
    this.setState({
      values: {
        ...this.state.values,
        [name]: value
      }
    })
  }

  downloadCsvModel = () => { 
    const csv = Papa.unparse(model)
    const csvData = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    let csvURL =  null;
    if (navigator.msSaveBlob)
    {
        csvURL = navigator.msSaveBlob(csvData, 'modelo.csv');
    }
    else
    {
        csvURL = window.URL.createObjectURL(csvData);
    }

    const tempLink = document.createElement('a');
    tempLink.href = csvURL;
    tempLink.setAttribute('download', 'modelo.csv');
    tempLink.click();
  }

  isBtnDisabled() {
    const { values, loadingCsv, errorOnStruct, isValidCsv, positionsFound } = this.state
    let disabled = false

    const toValidate = [
      'dsListName',
      'period',
      'idBranch',
    ]

    for (const field of toValidate) {
      if (isEmpty(values[field])) disabled = true
    }

    if (loadingCsv || errorOnStruct || !isValidCsv || positionsFound.length === 0) disabled = true

    return disabled
  }

  sameValues() {
    const { currentItem } = this.props
    const { values } = this.state
    let sameValues = true

    const toValidate = [
      'dsListName',
      'idBranch',
      'positionsPerDay',
    ]

    if (currentItem) {
      for (const field of toValidate) {
        if (values[field] !== currentItem[field]) sameValues = false
      }

      if (
        !moment(currentItem.dtBegin).isSame(values.period[0])
        || !moment(currentItem.dtEnd).isSame(values.period[1])
      ) {
        sameValues = false
      }
    } else {
      sameValues = false
    }

    return sameValues
  }

  changeFileAlert = () => {
    const { fileAlert } = this.state

    const index = fileAlerts.indexOf(fileAlert) + 1

    this.setState({ fileAlert: index === fileAlerts.length ? fileAlerts[0] : fileAlerts[index] })
  }

  renderNotification = () => {
    const { fileAlert } = this.state
    const { translate } = this.props

    return (
      <div onClick={() => this.changeFileAlert()} className={`cursor-pointer alert-box alert-box-${fileAlert.type} margin-bottom`}>
        <div className='flex flex-column align-items-start h-100'><img width={20} height={20} src={fileAlert.icon} /></div>
        <div className='flex flex-column'>
          <p><strong>{translate(fileAlert.type)}</strong> {translate(fileAlert.message[0])}</p>
          {fileAlert.message[1] && <p className='margin-top-small'>{translate(fileAlert.message[1])}</p>}
        </div>
      </div>
    )
  }

  validateCsv = (file) => { 
    if(file.type !== 'text/csv') {
      this.setState({errorText: 'Formato de arquivo inválido, envie apenas .csv'})
      return false
    }

    const fileSize = file.size; 
    const maxSize = 5 * 1024 * 1024; 

    if(fileSize > maxSize) {
      this.setState({errorText: 'Tamanho de arquivo inválido, envie no máximo 5 MB'})
      return false
    }

    if (fileSize === 0) { 
      this.setState({errorText: 'Arquivo vazio, escolha um novo arquivo para importação'})
      return false
    }

    return true

  }

  fetchPositions = async (store,type ) => {
    const {user, } = this.props
    const requestBody = {
      addressWharehouseRequest:
      { storeList: [{storeId:store,warehouseType:type}]}
    }

  return new Api(user.dsToken).post(API_URL.IRC_LIST_POSITIONS, requestBody)

  .then((response ) => response).catch((ex) =>  {
    console.log("Exception: ", ex)
  })
  }

  readCsv(file) { 

    const {user} = this.props
    const {values} = this.state
    const reader = new FileReader(); 
        // Event listener on reader when the file
        // loads, we parse it and set the data.
        reader.onload = async ({ target }) => {
          const csv = Papa.parse(target.result, {
              header: true,
              skipEmptyLines: true,
          });
      
          const parsedData = csv.data;

          const isEmpty = parsedData.length === 0

          if (isEmpty) {
            this.setState({errorText: "Arquivo vazio, escolha um novo arquivo para importação"}, () => {
              this.setState({errorOnStruct: true}, () => this.setState({loadingCsv: false}))
            })
            return
          }

          const header = Object.keys(csv.data[0]);
          const isValid = header.length === 2 && header[0] === 'Tipo de deposito' && header[1] === 'Posição'
        
          if (!isValid) { 
              this.setState({errorText: "Arquivo fora do padrão, encontramos colunas/linhas inválidas"}, () => {
                this.setState({errorOnStruct: true}, () => this.setState({loadingCsv: false}))
              })
            return
          }

          const rows = Object.keys(parsedData[0]); 
          const res = parsedData.map((row) => rows.map((column) => row[column]));
           
          const depositPositionList = res.map(([warehouseType, position]) => ({storeId:values.idBranch, warehouseType,position}))
          const requestBody = {
            addressWharehouseRequest:
            { storeList: depositPositionList}
          }
          return new Api(user.dsToken).post(API_URL.SUPPLY_MULTIPLE_LIST_POSITIONS, requestBody)
          .then((response) => {
            console.log(response)
            const positionsFound = response.data.positionsFound.map(value => ({storageBinId: value.position, warehouseType: value.warehouseType}))
            const positionsNotFound = response.data.positionsNotFound.map(value => value.position)
            const depositsNotFound = new Set(response.data.positionsNotFound.filter(value => value.warehouseNotFound === true).map(vl => vl.warehouseType))
            this.setState({positionsFound, positionsNotFound, depositsNotFound: Array.from(depositsNotFound)})
          })
          .catch((ex) => {
            console.log("Exception: ", ex)
          })
          .finally(() => this.setState({loadingCsv:false}))

      };
    
      reader.readAsText(file);
  }

  resetValues = () => {
    this.setState({...INITIAL_STATE, values: {dsListName: '',positionsPerDay: 1,period: [],idBranch: '', 
    },
    })
  }

  onSubmit = () => {
    const {onSubmit } = this.props

    const { values } = this.state

    values.dtBegin = values.period[0].format()
    values.dtEnd = values.period[1].format()
    values.upload = true
    values.storageBinList = this.state.positionsFound
    // this.setState({positionsFound: [], positionsNotFound: [], depositsNotFound: [], loadingCsv: false, errorOnStruct: false, isValidCsv: null, errorText: ''})
    // toggleUpload(false)
    onSubmit(values, this.resetValues)
  }

  renderWarningModal = () => { 
    const {showWarningModal} = this.state
    if(!showWarningModal) return 
    return (
      <WarningModal
        customClass='pictogram-warning-modal'
        customText='Gostaria de sair sem salvar?'
        
      />
    )
  }

  hasValues = () => { 
    
    const {values} = this.state
    const toValidate = [
      'dsListName',
      'idBranch',
      "period"
    ]
    
    for (const field of toValidate) {
       if(!isEmpty(values[field])) return true
    }

    return false
  }

  render() {
    const { toggleUpload, translate,  isUserMatriz, maxRange, user } = this.props
    const { values, loadingCsv, errorOnStruct, positionsNotFound, positionsFound, depositsNotFound} = this.state
    
    const enableOtherFields = values.idBranch.length > 0
    return (
    <>
      {this.renderWarningModal()}
      <SupplyModal
        isOpen
        disabledBgClickClosing
        downloadCsvModel={this.downloadCsvModel}
        disableClose={loadingCsv}
        title="Importar lista"
        className='irc-upload-modal-new'
        confirmButtonText={translate('save_button_label')}
        cancelButtonText={translate('close')}
        size={'md'}
        hasValues={this.hasValues()}
        noCloseOnConfirm
        onCloseModal={this.sameValues() ? () => toggleUpload(false) : () => toggleUpload(false)}
        onConfirm={this.onSubmit}
        isConfirmButtonDisabled={this.isBtnDisabled()}
      >

        <div className='w-100'>
          <BranchSelect
            required
            name='idBranch'
            label={translate('irc.store')}
            placeholder={translate('irc.choose-store')}
            translate={translate}
            onChange={(e) => {
              this.setState(
                {...INITIAL_STATE, values: {...values, dsListName: "", idBranch: e.target.value.value} }, 
                () => { 
                  this.setState({cleanFile: false})})
            }}
            value={values.idBranch}
            withoutRegions
            attrs={{
              fill: true
            }}
            disabled={!isUserMatriz || loadingCsv}
            excludeInactive={true}
          />
        </div>
        <div className='w-100'>
         
          {loadingCsv &&  
          <div className={`loading-status margin-bottom`} >
            <span>
                {translate('irc.upload.loading')}
            </span>
            <div className='bar' />
          </div>
          }
          <FileInput
            cleanFile={this.state.cleanFile}
            resetValue
            required
            errorOnStruct={errorOnStruct}
            successText={loadingCsv ? 'Carregando arquivo...' : 'Arquivo carregado com sucesso!'}
            validateValue={(f) => f[0].type === 'text/csv' && f[0].size <= 5 * 1024 * 1024 && f[0].size > 0 }
            errorText={this.state.errorText}
            disabled={!enableOtherFields}
            placeholder="Escolha um arquivo"
            hideFileInput={loadingCsv}
            className={`irc-supply-file-input`}
            helpText={translate('irc.file.help')}
            accept={'.csv'}
            onChange={(e) => {
              this.setState({errorOnStruct: false}, () => {
                this.setState({positionsFound: [], positionsNotFound: [], depositsNotFound: []})
                const file = e[0]
                if(this.validateCsv(file)) {
                  const addNameOnValues = {...values, dsListName: file.name}
                  this.setState({values: addNameOnValues})
                  this.setState({isValidCsv: true})
                  this.setState({loadingCsv: true})
                  this.readCsv(file)
                 
                }
                else {
                  this.setState({isValidCsv: false})
                }
              })
              
            }}
            label={'Anexar arquivo'}
            name='file'
          />
        </div>

       <div className='w-100'>

        {positionsNotFound.length > 0 && positionsFound.length > 0 &&
          <SupplyItemsNotFoundBox 
          topMsg='As seguintes posições não foram encontradas:' 
          bottomMsg='As posições acima não foram encontrados e não serão consideradas quando a lista for salva.' 
          items={positionsNotFound}
          />
        }

        {positionsFound.length === 0 && positionsNotFound.length > 0 &&

          <SupplyItemsNotFoundBox 
          error
          topMsg='Nenhuma posição foi encontrada.' 
          bottomMsg='Ajuste as posições do arquivo e refaça o upload.' 
          items={[]}
          />
        }

        {positionsFound.length === 0 && positionsNotFound.length > 0 && depositsNotFound.length > 0 &&
          <SupplyItemsNotFoundBox 
          error
          topMsg='Nenhum depósito foi encontrado.' 
          bottomMsg='Ajuste os depósitos do arquivo e refaça o upload.' 
          items={[]}
          />
        }

        {depositsNotFound.length > 0 && positionsFound.length > 0 &&
          <SupplyItemsNotFoundBox 
          topMsg='Os seguintes depósitos não foram encontrados:' 
          bottomMsg='Os depósitos acima não foram encontrados e não serão considerados quando a lista for salva.' 
          items={depositsNotFound}
          />
        }
       </div>

        <div className='w-100'>
          <TextField
            required
            readOnly={!enableOtherFields}
            disabled={!enableOtherFields}
            label={translate('irc.name')}
            placeholder={translate('irc.choose-name')}
            name={'dsListName'}
            fill
            onChange={(e) => this.handleChange('dsListName', e.target.value)}
            translate={translate}
            value={values.dsListName}
            validateValue={(v) => Boolean(v)}
          />
        </div>

        <div className='section-date-positions'>
          <NewDateIntervalInput
            disabled={!enableOtherFields}
            minDate={new Date()}
            useMinDate
            maxRange={maxRange}
            label={translate('field.period.hint')}
            required
            initialValue={
              values.period.length > 0 ? values.period : false
            }
            name={'period'}
            t={translate}
            onChange={(e) => this.handleChange('period', e)}
            noSelect
            disableAutoClose
            user={user}
          />

          <CounterInput
            name='counter-1'
            onChange={(e) => this.handleChange('positionsPerDay', e)}
            label='Posições por dia'
            helpText='Entre 1 até 999'
            value={values.positionsPerDay && values.positionsPerDay !== 0 ? values.positionsPerDay : 1}
            minValue={1}
            maxValue={999}
            disabled={!enableOtherFields}
            />

          {/* <TextField
            required
            label={translate('irc.position.per.day')}
            placeholder={translate('irc.type.position.per.day')}
            name={'positionsPerDay'}
            fill
            onChange={(e) =>
              this.handleChange('positionsPerDay', e.target.value)
            }
            mask={[...Array((MAX_COUNT).toString().length)].map(() => ('9')).join('')}
            translate={translate}
            value={values.positionsPerDay}
            validateValue={(v) => v && v.length > 0 && v >= 1 && v <= MAX_COUNT}
            helpText={translate('irc.supply.positions.per.day.help').replace('{to}', MAX_COUNT)}
            errorText={translate('irc.supply.positions.per.day.help').replace('{to}', MAX_COUNT)}
          /> */}
        </div>
      
      </SupplyModal>
    </>
    )
  }
}

export default UploadModal
export { UploadModal }
